import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/bootstrap/form-field';
import { FieldTypeConfig } from '@ngx-formly/core';
import { CardContentComponent } from '../../component/card-content/card-content.component';

interface DurationCardIndicatorOptions extends FormlyFieldProps {
  title: string;
  currentPeriodName: string;
  totalPeriodName: string;
  percentageValue: number;
  calculationFunction: string;
  evaluatedCalculationFunction: any;
}
@Component({
  selector: 'app-duration-card-indicator-field',
  imports: [CommonModule, CardContentComponent],
  templateUrl: './duration-card-indicator-field.component.html',
  styleUrl: './duration-card-indicator-field.component.scss',
})
export class DurationCardIndicatorFieldComponent
  extends FieldType<FieldTypeConfig<DurationCardIndicatorOptions>>
  implements OnInit
{
  public ngOnInit(): void {
    if (this.props.calculationFunction) {
      this.props.evaluatedCalculationFunction = eval(
        this.props.calculationFunction
      );
    }
  }
}
